// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"826":"8a1ab9da","970":"d5bb65a9"}[chunkId] + ".chunk.js";
};